export const CONSTANTS  = {
    'AUTHOR': 'Huzaifa Khan',
    'AUTHOR_GITHUB_LINK': 'https://github.com/HuzaifaKhanDeveloper',
}